<style>
#exportStatsModal .v--modal-box.v--modal {
  min-height: 285px !important;
  min-width: 450px !important;
}
#exportStatsModal *:not(.v-icon) {
  font-size: 12px;
}
#modalSelect__content--stats > div.v-menu__content.theme--light {
  top: 80px !important;
  left: 24px !important;
}
#exportStatsModal .v-input--selection-controls__ripple {
  display: none;
}
#exportStatsModal .v-label {
  color: black;
}
</style>

<template>
  <Modal
    modalName="exportStatsModal"
    title="Eksport statystyk"
    @opened="loadLayers"
    @saved="getStatistics"
    @closed="close"
    :buttons="['save']"
  >
    <v-layout wrap align-center>
      <p
        style="margin-top: 20px;"
      >Wybierz nazwę warstwy, a następnie zaznacz kolumny, dla których chcesz pobrać statystyki</p>
      <v-flex xs12 d-flex id="modalSelect__content--stats">
        <v-select
          :items="layers"
          item-text="full_name"
          placeholder="Wybierz warstwę"
          attach="#modalSelect__content--stats"
          height="16"
          @change="chooseLayer"
          :return-object="true"
        ></v-select>
      </v-flex>
      <v-flex xs12 d-flex v-if="chosenLayer">
        <ul>
          <span v-for="layer in chosenLayer.fields" :key="layer.name">
            <li class="list__container--el" style="display: flex">
              <v-checkbox
                v-model="selected"
                :label="layer.display_name"
                :value="layer.name"
                style="font-size: 18px;"
              ></v-checkbox>
            </li>
          </span>
        </ul>
      </v-flex>
    </v-layout>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

export default {
  components: {
    Modal
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    layersWater() {
      return this.$store.getters.getLayersWater;
    },
    layersSewer() {
      return this.$store.getters.getLayersSewer;
    }
  },
  data: () => ({
    layers: [],
    selected: [],
    chosenLayer: []
  }),
  methods: {
    show(title) {
      if (this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    loadLayers() {
      this.layers = this.layersWater;
      this.layers.concat(this.layersSewer);
    },
    chooseLayer(layer) {
      this.$store.dispatch("getLayer", layer.full_type).then(response => {
        if (response) {
          this.chosenLayer = response;
        } else {
          this.$root.$emit("showSnackbar", "red", `${response}`);
        }
      });
    },
    getStatistics() {
      let payload = {
        table: this.chosenLayer.type,
        name: this.chosenLayer.name,
        columns: `col=${this.selected.join("&col=")}`
      };
      this.$store.dispatch("getStatistics", payload).then(response => {
        if (response) {
          this.close();
        } else {
          this.$root.$emit("showSnackbar", "red", `${response}`);
        }
      });
    },
    close() {
      this.$modal.hide("exportStatsModal");
      this.layers = [];
      this.selected = [];
      this.chosenLayer = [];
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/viewer/analysis/modals/ExportStats.vue